/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const PlanningIcon = ({ isActive = false, className = "" }) => {
  let fill;
  if (isActive === false) {
    fill = "#9a9a9a";
  } else {
    fill = "white";
  }

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.74966 14.52C1.36142 14.52 1.02895 14.3819 0.752243 14.1056C0.476008 13.8289 0.337891 13.4965 0.337891 13.1082V3.22587C0.337891 2.83764 0.476008 2.5054 0.752243 2.22917C1.02895 1.95246 1.36142 1.81411 1.74966 1.81411H2.45554V0.402344H3.8673V1.81411H9.51436V0.402344H10.9261V1.81411H11.632C12.0202 1.81411 12.3527 1.95246 12.6294 2.22917C12.9057 2.5054 13.0438 2.83764 13.0438 3.22587V7.46117H11.632V6.0494H1.74966V13.1082H6.69083V14.52H1.74966ZM13.8379 10.9906L12.3379 9.49058L12.8497 8.97881C12.9791 8.8494 13.1438 8.7847 13.3438 8.7847C13.5438 8.7847 13.7085 8.8494 13.8379 8.97881L14.3497 9.49058C14.4791 9.61999 14.5438 9.7847 14.5438 9.9847C14.5438 10.1847 14.4791 10.3494 14.3497 10.4788L13.8379 10.9906ZM8.1026 15.2259V13.7259L11.8438 9.9847L13.3438 11.4847L9.6026 15.2259H8.1026ZM1.74966 4.63764H11.632V3.22587H1.74966V4.63764Z"
        fill={fill}
      />
    </svg>
  );
};

export default PlanningIcon;
